import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Servers from "@/pages/Servers";
import Users from "@/pages/Users";
import Chains from "@/pages/Chains";
import Deployments from "@/pages/Deployments";
import Settings from "@/pages/Settings";

import "@/App.css";

function Protected({ children }) {
    const { admin, checking } = useAuth();
    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center text-sm text-zinc-500">
                Проверка сессии…
            </div>
        );
    }
    if (!admin) return <Navigate to="/login" replace />;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Protected><Layout /></Protected>}>
                        <Route index element={<Dashboard />} />
                        <Route path="servers" element={<Servers />} />
                        <Route path="users" element={<Users />} />
                        <Route path="chains" element={<Chains />} />
                        <Route path="deployments" element={<Deployments />} />
                        <Route path="settings" element={<Settings />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
